import React, { useEffect } from "react";
import AppNavbar from "../components/home/Navbar";
import { Container } from "react-bootstrap";
import Footer from "../components/footer/Footer";
import Seo from "../components/seo/Seo";
import { PAGES } from "../content/pages";

function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <Seo {...PAGES.privacy} />
      <AppNavbar />
      <Container style={{ padding: "20px", justifyItems: "center" }}>
        <h2 style={{ color: "#051259", marginBottom: "40px" }}>
          Politique de confidentialité
        </h2>

        <div style={{ textAlign: "left", maxWidth: "1000px" }}>
          <h4 style={{ color: "#FF5500" }}>1. Introduction</h4>
          <p>
            Cette politique de confidentialité décrit comment Platform98
            collecte, utilise, protège et partage les informations personnelles
            des utilisateurs. En utilisant nos services, vous acceptez les
            conditions de cette politique.
          </p>

          <h4 style={{ color: "#FF5500" }}>2. Informations collectées</h4>

          <h5 style={{ color: "#FF5500" }}>2.1 Informations personnelles</h5>
          <p>
            Nous pouvons collecter des informations personnelles lorsque vous :
          </p>
          <ul>
            <li>Créez un compte.</li>
            <li>Remplissez un formulaire de contact.</li>
            <li>Effectuez une transaction ou un paiement.</li>
            <li>Interagissez avec notre service client.</li>
          </ul>
          <p>
            Les informations collectées peuvent inclure, mais ne sont pas
            limitées à :
          </p>
          <ul>
            <li>Nom</li>
            <li>Adresse e-mail</li>
            <li>Numéro de téléphone</li>
            <li>Adresse postale</li>
            <li>Informations de paiement</li>
          </ul>

          <h5 style={{ color: "#FF5500" }}>
            2.2 Informations non personnelles
          </h5>
          <p>
            Nous collectons également des informations non personnelles, telles
            que :
          </p>
          <ul>
            <li>
              Données d'utilisation (ex : pages visitées, temps passé sur le
              site).
            </li>
            <li>
              Informations sur l'appareil (ex : type d'appareil, système
              d'exploitation).
            </li>
            <li>Adresse IP.</li>
          </ul>

          <h4 style={{ color: "#FF5500" }}>3. Utilisation des informations</h4>
          <p>Platform98 utilise les informations collectées pour :</p>
          <ul>
            <li>Fournir et gérer nos services.</li>
            <li>Traiter les transactions et envoyer des confirmations.</li>
            <li>
              Communiquer avec les utilisateurs concernant leur compte ou leurs
              demandes.
            </li>
            <li>
              Améliorer nos services et personnaliser l'expérience utilisateur.
            </li>
            <li>
              Envoyer des newsletters et des offres promotionnelles (avec
              consentement).
            </li>
          </ul>

          <h4 style={{ color: "#FF5500" }}>4. Protection des informations</h4>
          <p>
            Nous mettons en œuvre des mesures de sécurité appropriées pour
            protéger vos informations personnelles contre tout accès non
            autorisé, utilisation ou divulgation. Cela inclut l'utilisation de
            la technologie SSL pour sécuriser les données sensibles lors de la
            transmission.
          </p>

          <h4 style={{ color: "#FF5500" }}>5. Partage des informations</h4>
          <p>
            Platform98 ne vend ni ne loue vos informations personnelles à des
            tiers. Nous pouvons partager vos informations dans les cas suivants
            :
          </p>
          <ul>
            <li>
              Avec des prestataires de services tiers qui nous aident à fournir
              nos services (ex : traitement des paiements).
            </li>
            <li>
              Pour se conformer à la loi ou répondre à des demandes légales.
            </li>
            <li>Dans le cadre d'une fusion, acquisition ou vente d'actifs.</li>
          </ul>

          <h4 style={{ color: "#FF5500" }}>6. Vos droits</h4>
          <p>Vous avez le droit de :</p>
          <ul>
            <li>Accéder à vos informations personnelles que nous détenons.</li>
            <li>Demander la correction ou la suppression de vos données.</li>
            <li>
              Retirer votre consentement à l'utilisation de vos données à des
              fins marketing.
            </li>
          </ul>
          <p>
            Pour exercer ces droits, veuillez nous contacter via les coordonnées
            fournies ci-dessous.
          </p>

          <h4 style={{ color: "#FF5500" }}>7. Cookies</h4>
          <p>
            Platform98 utilise des cookies pour améliorer l'expérience
            utilisateur sur notre site. Les cookies sont de petits fichiers
            stockés sur votre appareil qui nous aident à analyser le trafic et à
            personnaliser le contenu.
          </p>
          <p>
            Vous pouvez choisir d'accepter ou de refuser les cookies via les
            paramètres de votre navigateur. Cependant, cela peut affecter votre
            expérience sur notre site.
          </p>

          <h4 style={{ color: "#FF5500" }}>8. Modifications de la politique</h4>
          <p>
            Nous nous réservons le droit de modifier cette politique de
            confidentialité à tout moment. Les modifications seront publiées sur
            notre site web avec une date d'entrée en vigueur.
          </p>

          <h4 style={{ color: "#FF5500" }}>9. Contact</h4>
          <p>
            Pour toute question concernant cette politique de confidentialité ou
            pour exercer vos droits, veuillez nous contacter :
          </p>
          <ul>
            <li>Email : support@platform98.com</li>
            <li>Téléphone : +33972119472 / +237677200200</li>
          </ul>
          <p>Cette politique a été mise à jour le 23 février 2025.</p>

          {/* <h4 style={{ color: "#FF5500" }}>
            Quelles informations personnelles sont collectées par Platform98
          </h4>
          <p>
            Platform98 collecte plusieurs types d'informations personnelles lors de l'utilisation de ses services. Voici les principales catégories d'informations collectées :
          </p>
          <ul>
            <li><strong>Informations d'identification :</strong> Nom, prénom, et éventuellement des informations supplémentaires comme le numéro d'identification nationale.</li>
            <li><strong>Coordonnées :</strong> Adresse e-mail, numéro de téléphone et adresse postale pour la communication et la gestion des comptes.</li>
            <li><strong>Informations de paiement :</strong> Données telles que les informations de carte bancaire ou autres détails financiers pour traiter les paiements.</li>
            <li><strong>Données relatives à l'entreprise :</strong> Pour les utilisateurs qui créent une entreprise, des informations spécifiques sur l'entreprise peuvent être requises.</li>
            <li><strong>Données comportementales :</strong> Platform98 collecte également des informations sur l'utilisation du service, telles que les pages visitées et le temps passé sur le site, afin d'améliorer l'expérience utilisateur.</li>
          </ul>
          <p>Ces informations sont utilisées pour fournir et gérer les services, communiquer avec les utilisateurs et améliorer les offres de Platform98.</p>

          <h4 style={{ color: "#FF5500" }}>
            Comment Platform98 protège-t-il les données personnelles des utilisateurs
          </h4>
          <p>Platform98 met en œuvre plusieurs mesures de sécurité pour protéger les données personnelles :</p>
          <h5 style={{ color: "#FF5500" }}>1. Conformité au RGPD</h5>
          <ul>
            <li><strong>Consentement explicite :</strong> Les utilisateurs doivent donner leur consentement clair avant la collecte de leurs données.</li>
            <li><strong>Droits des utilisateurs :</strong> Accès, rectification, suppression et opposition au traitement de leurs données.</li>
          </ul>
          <h5 style={{ color: "#FF5500" }}>2. Sécurité des données</h5>
          <ul>
            <li><strong>Cryptage :</strong> Technologies de cryptage pour protéger les données sensibles.</li>
            <li><strong>Contrôles d'accès :</strong> Données stockées sur des VPS haute sécurité chez OVH, accessibles uniquement aux employés autorisés.</li>
          </ul>
          <h5 style={{ color: "#FF5500" }}>3. Sécurité physique</h5>
          <p>Des mesures de sécurité sont mises en place pour protéger les infrastructures où les données sont stockées.</p>
          <h5 style={{ color: "#FF5500" }}>4. Sensibilisation et formation</h5>
          <p>Tous les employés reçoivent une formation sur la protection des données et la sécurité.</p>
          <h5 style={{ color: "#FF5500" }}>5. Politique de confidentialité</h5>
          <p>La politique est régulièrement mise à jour pour refléter les pratiques actuelles.</p>

          <h4 style={{ color: "#FF5500" }}>
            Quelles sont les options d'utilisateur pour gérer leurs données personnelles chez Platform98
          </h4>
          <p>Les utilisateurs disposent des droits suivants :</p>
          <ul>
            <li><strong>Droit d'accès :</strong> Consulter les données personnelles détenues par Platform98.</li>
            <li><strong>Droit de rectification :</strong> Corriger ou mettre à jour des données incorrectes.</li>
            <li><strong>Droit à l'effacement :</strong> Supprimer des données non nécessaires.</li>
            <li><strong>Droit de limitation :</strong> Restreindre le traitement de certaines données.</li>
            <li><strong>Droit d'opposition :</strong> S'opposer à l'utilisation des données à des fins de marketing.</li>
            <li><strong>Droit à la portabilité :</strong> Transférer ses données vers un autre service.</li>
            <li><strong>Retrait du consentement :</strong> Annuler le consentement donné pour le traitement des données.</li>
            <li><strong>Contact :</strong> Pour toute demande, les utilisateurs doivent contacter Platform98 via les coordonnées fournies.</li>
          </ul> */}
        </div>
      </Container>
      <Footer />
    </>
  );
}

export default PrivacyPolicy;
